<template>
  <div class="uk-grid-medium uk-flex-center uk-child-width-expand@s SectionTwo" uk-grid>
    <div>
      <article class="uk-article">
        <h2 class="uk-article-title AppTitle Title"><a class="uk-link-reset">{{'the_location'|translate}}</a></h2>
<!--        <p class="uk-article-meta">{{moto}}</p>-->
        <p class="uk-text-lead Description">{{description}}</p>
      </article>
    </div>
    <div>
      <div class="uk-cover-container uk-height-large">
        <iframe
          :src="embeddedMapUrl"
          width="800" height="450" frameborder="0" allowfullscreen></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertySectionThree',
  props: ['moto', 'description', 'embeddedMapUrl']
}
</script>

<style scoped>
  .SectionTwo {
    padding-top: 80px;
  }

  .Title {
    font-family: 'Kaushan Script', cursive !important;
  }

  .Description {
    font-size: 18px;
    margin-bottom: 25px;
  }
</style>
